import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acbcb2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mark" }, "M", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: "/",
    class: "home"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("span", {
        class: _normalizeClass(["brand", `brand--${_ctx.currentLanguage}`])
      }, _toDisplayString(_ctx.$t('navigation.navbar.appTitle')), 3)
    ]),
    _: 1
  }))
}